import React from 'react'

import { Button, Element, ElementProps, Text } from "components/shared/base"
import {
  PrismicHomepageDataBodyFourColumnItem,
  PrismicHomepageDataBodyFourColumnPrimary
} from "types/__generated__/gatsby-graphql"

interface OwnProps {
  borderAboveItems:  PrismicHomepageDataBodyFourColumnPrimary["border_above_repeatable_items"]
  index: number
  item: PrismicHomepageDataBodyFourColumnItem
}

export type FourColumnItemProps = OwnProps & Omit<ElementProps, "errors">

const FourColumnItem: React.FC<FourColumnItemProps> = ({
  borderAboveItems,
  index,
  item: { button_text, button_url, text, title },
  ...elementProps
}): React.ReactElement | null => {

  const titleText = title?.text || "";

  if (!title && !titleText) {
    return null;
  }

  const buttonUrl = button_url && button_url.url;

  return (
    <Element
      {...elementProps}
      gridColumnEnd={["span 12", "span 3"]}
      mt={index === 0 ? "0" : ["60px", "0"]}>
      {titleText && <Text as="h3" alignSelf="flex-end">{titleText}</Text>}
      {text && (
        <Text 
          borderColor="textPrimary"
          borderTop={borderAboveItems ? "1px solid" : '0'}
          mt={titleText ? '20px': '0'}
          pt={["20px", "35px"]}
        >
          {text}
        </Text>
      )}
      {button_text && buttonUrl && (
        <Text mt={["20px", "35px"]}>
          <Button href={buttonUrl} text={button_text} />
        </Text>
      )}
    </Element>
  )
}

export default FourColumnItem
